import axios from "axios";
import { API_END_POINTS } from "../../API_END_POINTS";

const ProductUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.product}`;
const NewArrivalUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.newArrival}`;
const SpecificProductsUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.specificProducts}`;
const RelatedProductsUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.relatedProducts}`;

// Login user function
export const ProductServices = async (shopId, lang) => {
  try {
    const authToken = localStorage.getItem("authToken");

    const headers = {
      lang: lang || "de",
      ...(authToken ? { authorization: `Bearer ${authToken}` } : {}), // Include only if authToken exists
    };

    const response = await axios.get(`${ProductUrl}/${shopId}`, {
      headers: headers,
    });
    return response; // Ensure this returns the expected data structure
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while fetching product details.";
    throw new Error(errorMessage);
  }
};

export const NewArrivalServices = async (lang, bodyData = {}) => {
  try {
    const authToken = localStorage.getItem("authToken");

    const headers = {
      lang: lang || "de",
      ...(authToken ? { authorization: `Bearer ${authToken}` } : {}),
    };

    // POST request instead of GET
    const response = await axios.post(`${NewArrivalUrl}`, bodyData, {
      headers: headers,
    });

    return response; // returns the complete Axios response
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while fetching product details.";
    throw new Error(errorMessage);
  }
};

export const SpecificProductsServices = async (lang, bodyData = {}) => {
  try {
    const authToken = localStorage.getItem("authToken");

    const headers = {
      lang: lang || "de",
      ...(authToken ? { authorization: `Bearer ${authToken}` } : {}),
    };

    // POST request instead of GET
    const response = await axios.post(`${SpecificProductsUrl}`, bodyData, {
      headers: headers,
    });

    return response; // returns the complete Axios response
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while fetching product details.";
    throw new Error(errorMessage);
  }
};

export const fetchRelatedProductsServices = async (lang, bodyData = {}) => {
  try {
    const authToken = localStorage.getItem("authToken");

    const headers = {
      lang: lang || "de",
      ...(authToken ? { authorization: `Bearer ${authToken}` } : {}),
    };

    const response = await axios.post(`${RelatedProductsUrl}`, bodyData, {
      headers,
    });

    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while fetching product details.";
    throw new Error(errorMessage);
  }
};
